var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {};
OCS.BootFunctions.dependencies = OCS.BootFunctions.dependencies || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.Console = new Class({
    Implements: [Events],
    debug: true,
    initialize: function () {
        this.log("OCS.console: OCS.Classes.console initialized.");
        if (OCS.console) {
            return OCS.console;
        }
        OCS.console = this;

        this.addEvent('warning', this.warn.bind(this));
        this.addEvent('debug', this.debug_text.bind(this));
        this.addEvent('log', this.log.bind(this));
        this.addEvent('error', this.error.bind(this));

    },
    on_loading_phase_completed: function(type) {
        this.debug_text('Loading Phase Completed: '+type);
    },
    help: function () {
        this.debug_text("All commands for the console are prefixed with 'OCS.console.' Available commands: ");
        this.debug_text("add_radar(site_id, name, lat, lon)");
        this.debug_text("debug_map(map_number)");
        this.debug_text("stop_debugging_map(map_number)");
        this.debug_text("goto_time(epoch_time_in_milliseconds)");
        this.debug_text("set_duration_hours(hours)");
        this.debug_text("restart_ui()");
        this.debug_text("dubug_ui()");

    },
    /**
     * @method add_radar - Add a radar to the constants file allowing other radars than the default to be loaded.
     * @param {String} site_id
     * @param {String} name
     * @param {float} lat
     * @param {float} lon
     * @return {undefined}
     */
    add_radar: function (site_id, name, lat, lon) {
        if (site_id && site_id.length === 4) {
            var site = {id: site_id.toUpperCase()};
            if (name) {
                site['name'] = name;
            }
            if (lat) {
                site['lat'] = lat;
            }
            if (lon) {
                site['lon'] = lon;
            }
            if (OCS.Viewer) {
                if (OCS.Viewer.add_radar(site)) {
                    this.debug_text('OCS.console: Success. Radar Added. Add a new radar product to the briefing to see the new option.');
                }
            }
        }
    },
    /*
     * 
     * @param {int} map_num
     * @return {undefined}
     */
    debug_map: function (map_num) {
        var obj = $('#map_' + map_num);
        if (obj) {
            var map = obj.data('ocsmap');
            if (map) {
                map.set_debug(true);
                this.debug_text('OCS.console: Success');
            }
        }
    },
    debug_ui: function () {
        this.set_debug(true);
        OCS.WxBriefing.Live.UI.set_debug(true);
        OCS.Bootstrap.restart_ui(function () {
            OCS.WxBriefing.Live.UI.set_debug(true);
        });
    },
    stop_debugging_map: function (map_num) {
        var obj = $('#map_' + map_num);
        if (obj) {
            var map = obj.data('ocsmap');
            if (map) {
                map.set_debug(false);
                this.debug_text('OCS.console: Success');
            }
        }
    },
    /**
     * 
     * @param {int} time - Time in milliseconds since the epoch reference time.
     * @return {undefined}
     */
    goto_time: function (time) {
        OCS.Bootstrap.stop(function () {
            if (OCS.Viewer) {
                var dateObj = new OCS.Viewer.Class.DateTime();
                dateObj.set_fixed_reference_time(time);
            }
            setTimeout(function () {
                OCS.Bootstrap.init_ui();
                OCS.WxBriefing.Live.UI.set_actively_retrieve_data(false);
                OCS.Bootstrap.start_ui();
                this.debug_text('OCS.console: Success.');
            }, 500);
        });
    },
    /**
     * @method set_duration_hours (1 - 8)
     * @param {int} hours
     * 
     */
    set_duration_hours: function (hours) {
        if (OCS.Viewer) {
            var dateObj = new OCS.Viewer.Class.DateTime();
            dateObj.set_time_duration_hours(hours);
            this.debug_text('OCS.console: Success.');
        }
    },
    /**
     * @method load - Used to load the basic scripts needed for website initialization
     * 
     */
    load: function () {
        OCS.Bootstrap.load();
        this.debug_text('OCS.console: Success.');
    },
    /**
     * @method startup - Used to perform the initial startup sequence after all the files have been loaded
     * 
     */
    startup: function () {
        OCS.Bootstrap.startup();
        this.debug_text('OCS.console: Success.');
    },
    /**
     * @method restart_ui - Used to restart the UI
     * 
     */
    restart_ui: function () {
        OCS.WxBriefing.Live.Controller.restart_ui()
    },
    log: function (text) {
        console.log(text);
    },
    warn: function (text) {
        console.warn(text);
    },
    error: function (text) {
        console.error(text);
    },
    debug_text: function (text) {
        if (this.debug) {
            console.debug(text);
        }
    },
    set_debug: function (cond) {
        //this.debug = cond;
    }
}); // End OCS.Classes.console
OCS.BootFunctions.dependencies.boot_console = function () {
    // Start the console
    new OCS.WxBriefing.Classes.Console();
    if (OCS.Bootstrap.debug) {
        OCS.console.set_debug(true);
        OCS.Bootstrap.addEvent('loading_phase_completed', OCS.console.on_loading_phase_completed.bind(OCS.console));
    }
}